import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createTransferOrderButton: {
    defaultMessage: 'Create Order',
    id: 'FeshPT',
    description: 'Create Transfer Order Button',
  },
});
